import request from "@/api";

export function listGoodsType(data) {
    return request({
        url: '/api/goods/getGoodsTypeList',
        method: 'get',
        params: data
    })
}

export function listGoodsTypeCache(data) {
    return request({
        url: '/api/goods/getGoodsTypeCacheList',
        method: 'get',
        params: data
    })
}

export function getGoodsTypeInfo(data) {
    return request({
        url: '/api/goods/getGoodsTypeInfo',
        method: 'get',
        params: data
    })
}

export function saveGoodsType(data) {
    return request({
        url: '/api/goods/saveGoodsType',
        method: 'post',
        data: data
    })
}

export function deleteGoodsType(data) {
    return request({
        url: '/api/goods/deleteGoodsType',
        method: 'post',
        data: data
    })
}